<span *ngFor="let tag of tags" class="media-tag" (click)="selectTag(tag)">#{{tag.tagName}}</span>